import { render, staticRenderFns } from "./EditSellerAltCodeTooltipContent.vue?vue&type=template&id=3e2ab23c&scoped=true&"
import script from "./EditSellerAltCodeTooltipContent.vue?vue&type=script&lang=js&"
export * from "./EditSellerAltCodeTooltipContent.vue?vue&type=script&lang=js&"
import style0 from "./EditSellerAltCodeTooltipContent.vue?vue&type=style&index=0&id=3e2ab23c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2ab23c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kontalk/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VIcon,VLayout})
